import { axiosInstance, trackEvent } from "@hopper-b2b/api";
import { NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { apiConfig } from "../../utils/urlPaths";
import { fetchUserInfoPath } from "../paths";

export type FetchUserInfoRequest = unknown;

export interface UberUserInfo {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  riderId: string;
  hopperUserIdToken?: string;
  kustomerAccessToken: string;
}

export const fetchUserInfo = (
  userInfoRequest: FetchUserInfoRequest
): Promise<UberUserInfo> =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        fetchUserInfoPath,
        userInfoRequest
      );
      resolve(response.data);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
export default fetchUserInfo;
